import { makeStyles } from "@fluentui/react-components";
import { designTokens } from "theme/customTheme";

export const useEditAccessLLMModelStyles = makeStyles({
  modelNameRow: {
    display: "flex",
    alignItems: "center",
    gap: designTokens.spacing[1],
    marginTop: designTokens.spacing[3],
  },
  fieldSpacing: {
    marginTop: designTokens.spacing[3],
  },
  errorMessage: {
    color: designTokens.semantic.error,
    fontSize: designTokens.fontSize.sm,
  },
});
